import { Turbo } from "@hotwired/turbo-rails";

// Mediavine adhesion ads don't work with Turbo Drive, so the layout flags
// ad-eligible pages via this meta tag (see layouts/partials/_head.html.erb).
if (document.querySelector('meta[name="turbo:drive-disabled"]')) {
  Turbo.session.drive = false;
}

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from '@alpinejs/collapse';
import sticky from 'alpinejs-sticky'

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(sticky)

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import Cookies from "js-cookie";
window.Cookies = Cookies;

import "./src/turbo_stream_visit";
import "./src/analyzer_confetti";
import "./src/detect_ingredient_count";

import "./src/handle_pushed_states";
import "./src/review_search";
import "./src/web_analytics";
import "./controllers";
import "./src/prevent_clear_snapshot_cache";
import "./src/touch_prefetch";
import "./src/trigger_native_haptic";
import "./src/trigger_native_review";
import "./src/trigger_native_notification_prompt";
import "./src/trigger_native_share";

import { handleSubmitButtonState } from "./src/submit_button_handler"
window.handleSubmitButtonState = handleSubmitButtonState // Make it available globally

document.addEventListener("DOMContentLoaded", () => {
  Alpine.start();
});


document.addEventListener("turbo:load", function () {
  let userTimeZone =
    new Intl.DateTimeFormat().resolvedOptions().timeZone ||
    "America/Los_Angeles";
  Cookies.set("user_time_zone", userTimeZone);

  addEventListener("turbo:before-stream-render", (event) => {
    const fallbackToDefaultActions = event.detail.render;

    event.detail.render = function (streamElement) {
      if (streamElement.action == "redirect") {
        window.location.href = streamElement.getAttribute("location");
      } else {
        fallbackToDefaultActions(streamElement);
      }
    };
  });
});

addEventListener("turbo:before-frame-render", (event) => {
  if (document.startViewTransition && event.target.classList.contains('should-view-transition')) {
    const originalRender = event.detail.render
    event.detail.render = (currentElement, newElement) => {
      document.startViewTransition(() => originalRender(currentElement, newElement))
    }
  }
})


export function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

window.sendAnalyticsEvent = function sendAnalyticsEvent(action) {
  gtag("event", action, {
    current_path: window.location.pathname,
  });
};

// Add an after-stream-render event
// Taken from https://discuss.hotwired.dev/t/event-to-know-a-turbo-stream-has-been-rendered/1554/24
const afterRenderEvent = new Event("turbo:after-stream-render");
addEventListener("turbo:before-stream-render", (event) => {
  const originalRender = event.detail.render;

  event.detail.render = function (streamElement) {
    originalRender(streamElement);
    document.dispatchEvent(afterRenderEvent);
  };
});
